<template>
    <b-form-radio-group v-model="value" :options="schema.values" v-bind="{ ...schema, ...schema.attributes }"></b-form-radio-group>
</template>

<script>
    import { abstractField } from "vue-form-generator";
    export default {
        mixins: [abstractField]
    };
</script>

<style></style>
